import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

// เหตุผลบังคับกรอก — การแก้ยอดที่ปิดกะไปแล้วต้องอธิบายได้เสมอว่าแก้เพราะอะไร
// ส่วนยอดรายช่องทาง validate ทีละแถวในฟอร์ม (ต้องเป็นตัวเลขถ้ากรอก)
export default function (formState) {
  return {
    form: {
      reason: {
        required: helpers.withMessage(i18n.global.t('Please enter a reason.'), required)
      }
    }
  }
};
